module.exports = __webpack_public_path__ + "img/avatar7.4d1c6d92.png";